<template>
    <router-view/>
</template>

<script>
import store from "@/store"
export default {
    name: 'App',
    created(){
        // 解决刷新后shopInfo被清除的问题，刷新时加载顺序app -> 子路由 -> index页面
        const shopInfo = this.$util.getLocalStorage('shopInfo');
        if(shopInfo && shopInfo !== 'undefined' && shopInfo !== 'null'){
            // 放入全局参数
            store.commit('setShopInfo', shopInfo);
        }
    }
}
</script>
